import React from "react";
import { useApp } from "@/context/AppContext";

const SRC = "/brand/halal.png";

export function HalalBadge({ className = "", size = "md", text: textOverride }) {
  const { settings } = useApp();
  const badge = settings?.halal_badge;
  if (badge && badge.active === false) return null;
  const label = textOverride || badge?.text || "100% HALAL";
  const sizes = { sm: "h-12", md: "h-16", lg: "h-24" };
  return (
    <span
      data-testid="halal-certified-badge"
      role="img"
      aria-label={label}
      title={label}
      className={`halal-badge-img relative inline-block ${sizes[size] || sizes.md} ${className}`}
    >
      <img src={SRC} alt={label} className="h-full w-auto object-contain" draggable={false} />
      <span className="halal-badge-shine pointer-events-none absolute inset-0" style={{ WebkitMaskImage: `url(${SRC})`, maskImage: `url(${SRC})` }} />
    </span>
  );
}
